import axiosInstance from "../mainService";

const careerService = {
    getCareers(search, page, limit, company) {   
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/data/m150_careers/positions/${sanitizedSearch}/${page}/${limit}/${company}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        })
    },
    getCareerDetail(id){
        return axiosInstance.get(`/careers-detail/${id}`).then(response => {
            return {
                data: response,
            };
        });
    },
    totalAllCareers(search, company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/count-data/m150_careers/positions/${sanitizedSearch}/${company}`);
    },
    totalAllCareersActive(search, company_id) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/count-data/m150_careers/positions/${sanitizedSearch}/active/${company_id}`);
    },
    addCareer(data) {
        return axiosInstance.post('/insert-data/m150_careers', data);
    },
    deleteCareer(careerId) {
        return axiosInstance.delete(`/delete-data/m150_careers/${careerId}`);
    },
    updateCareer(data) {
        return axiosInstance.put(`/update-data/m150_careers/${data.id}`, data);
    },
    updateStatusCareerDetail(requirement) {
        return axiosInstance.put(`/update-data/t105_career_details/${requirement.id}`, requirement);
    }
};

export default careerService;